// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"0c9c84aa","582":"7a5ffc20","758":"dd9b708e","844":"aa55bc92"}[chunkId] + ".css";
};